<template>
  <div class="receptionOverflow">
    <div class="flex">
      <div class="blockThree">
        <span class="label">输入金额：</span>
        <el-input v-model="money" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" class="input_s200" placeholder="请输入金额" @change="editMoney" @input="newTest" @keyup.enter.native="Lib.keyboardBlur">
          <template slot="prepend">￥</template>
        </el-input>
      </div>
      <div class="blockThree" style="display: flex;width: 500px;">
        <span class="label">金额备注：</span>
        <el-input v-model="textarea" style="flex: 1;padding-left: 20px;" type="textarea" maxlength="50" :rows="3" placeholder="请输入内容50个字符以内"></el-input>
      </div>
      <!-- <div class="payStyleBox">
                <div class="pay-box-header">
                    <strong>结算信息</strong>
                </div>
                <div class="payInfo">
                    <p>消费金额：￥0.00</p>
                    <p>优惠金额：￥0.00</p>
                    <p>应收金额：
                        <span>￥0.00</span>
                    </p>
                </div>
            </div> -->
      <div class="payStyleBox" style="margin-top: 30px;">
        <div class="pay-box-header">
          <strong>选择支付方式 </strong>
        </div>
        <div class="pay-box-body clearFix" style="height:auto;overflow: hidden;">
          <div>
            <div v-for="(v,n) in payTypeList" :key="n" class="pay-mode-box">
              <a :class="choosePayStatus == v.type ? 'checked' : ''" @click="choosePay(v.type)">
                <i class="iconfont" :class="choosePayStatus == v.type ? (''+v.icon) : ('themeFC '+v.icon)"></i>
                <span>{{ v.name }}</span>
              </a>
            </div>
            <!-- <div class="pay-mode-box">
                            <a @click="choosePay('2')" :class="choosePayStatus == 2 ? 'checked' : ''">
                                <i class="iconfont" :class="choosePayStatus == 2 ? '' : 'themeFC'">&#xe705;</i>
                                <span>银行卡支付</span>
                            </a>
                        </div>
                        <div class="pay-mode-box">
                            <a @click="choosePay('4')" :class="choosePayStatus == 4 ? 'checked' : ''">
                                <i class="iconfont" :class="choosePayStatus == 4 ? '' : 'themeFC'">&#xe618;</i>
                                <span>扫码支付</span>
                            </a>
                        </div> -->
          </div>
          <div v-show="choosePayStatus == 2" style="width: 100%;overflow:hidden">
            <!-- <el-input @keyup.enter.native="Lib.keyboardBlur" v-model.trim="bankCode" placeholder="请输入银行流水号" style="width:250px;">
            </el-input> -->
          </div>
        </div>
      </div>
      <div class="commonFooterBtnTwo">
        <el-button type="primary" :disabled="!money" @click="confirmPay">确认收款</el-button>
      </div>
      <el-dialog title="扫码支付" :visible.sync="innerVisible" width="590px" :append-to-body="true" :close-on-click-modal="false" :show-close="!scanQPayLoading" @close="clearBusinessLimit">
        <div class="commonNewPay" style="width: 500px;">
          <img style="margin: auto;display: block;margin-bottom: 20px;" src="static/images/default/scanCode.gif" />
          <p>
            需支付金额：
            <span v-text="'¥'+money"></span>
          </p>
          <img class="hdScanIcon" src="static/images/icon/Scan.png" @click="getHdCamera" />
          <el-input ref="refsqp" v-model="paymentCode" v-focus :disabled="scanQPayLoading" placeholder="使用扫码枪扫码或输入付款码" class="input-with-select scanInput" style="width: 300px;    margin: 10px 90px 10px 92px;" @keyup.enter.native="scanQPaySubmit">
            <el-button slot="append" type="primary" style="color: #fff;height: 40px;" :loading="scanQPayLoading" @click="scanQPaySubmit">确定</el-button>
          </el-input>
          <p class="themeFC">支付过程中请勿关闭窗口，因网络问题引起的延迟，请耐心等候</p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  saveOrder, getScanPayStatus, getOrderCode, newBarCodePay, getPaySet, getPayCodeList, toPayBefore
} from './api';

export default {
  data() {
    return {
      money: '',
      textarea: '',
      choosePayStatus: '0',
      innerVisible: false,
      getWxQRcode: '',
      bankCode: '',
      setInterFlag: null,
      changePayImgStatus: true, // 扫码支付切换支付方式，true为微信支付，fasle为支付宝支付
      paymentCode: '', // 扫码支付付款码
      scanQPayLoading: false, // 扫码支付--确定loading
      sanQPayOrder: '', // 扫码支付订单号

      paySetStatus: '',
      payTypeList: [],
      totalNum: 0,
    };
  },
  activated() {
    Object.assign(this.$data, this.$options.data());
    const vm = this;
    vm.getPayList();
    window.didGetQRCode = vm.returnHdCameraVal;
    getPaySet({}).then((res) => {
      if (res.code == 0) {
        vm.paySetStatus = res.data ? res.data : 0;
      }
    });
  },
  methods: {
    editMoney(val) {
      this.money = val;
    },
    // 获取支付方式列表--5.5优化
    getPayList() {
      const data = {
        mainId: window.sessionStorage.mainId
      };
      getPayCodeList(data).then((res) => {
        if (res.code == 0 && res.data) {
          res.data.forEach((a) => {
            if ((a.payType * 1 < 10 || a.payType * 1 > 99) && a.isOpen == 0 && a.payType * 1 != 3 && a.payType * 1 != 5 && a.payType * 1 != 6) {
              const obj = {};
              obj.icon = a.payType == 1 ? 'icon-zhifu-01' : a.payType == 2 ? 'icon-yinhangqia' : a.payType == 4 ? 'icon-saoma1' : a.payType == 7 ? 'icon-weixin2' : a.payType == 8 ? 'icon-zhifubao' : 'icon-zhifufangshi';
              obj.isOpen = 0;
              obj.name = a.payTypeName;
              obj.price = null;
              obj.status = false;
              obj.type = a.payType;
              this.payTypeList.push(obj);
            }
          });
        } else {
          this.payTypeList = [];
        }
      });
    },
    // 调用HD摄像头功能
    getHdCamera() {
      const status = this.Lib.pcOrMobile();
      if (status === 'mobile') {
        if (window.webkit) {
          window.webkit.messageHandlers.scanQRCode.postMessage(1);
        } else if (typeof (dfAndroidAppHD) != 'undefined') {
          // eslint-disable-next-line no-undef
          dfAndroidAppHD.openScanQRCode('1');
        } else {
          this.$message('此功能只能在HD上使用');
        }
      }
    },
    // 摄像头回调方法
    returnHdCameraVal(code) {
      this.paymentCode = code;
    },
    newTest(val) {
      console.log(val);
    },
    // 验证银行卡
    CheckBankNo(val) {
      const bankno = val.replace(/\s/g, '');
      if (bankno == '') {
        return false;
      }
      if (bankno.length < 16 || bankno.length > 19) {
        return false;
      }
      const num = /^\d*$/;// 全数字
      if (!num.exec(bankno)) {
        return false;
      }
      // 开头6位
      const strBin = '10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99';
      if (strBin.indexOf(bankno.substring(0, 2)) == -1) {
        return false;
      }
      return true;
    },
    // 选择支付方式
    choosePay(val) {
      this.bankCode = '';
      if (!this.money) {
        console.log(this.money);
        this.$message.error('请输入金额');
        return;
      }
      if (val == 4) {
        if (this.paySetStatus == 0) {
          this.$message('您尚未开通扫码支付');
          return;
        }
        this.getOrderCode();
      }
      this.choosePayStatus = val;
    },
    // 获取二维码支付
    getOrderCode() {
      this.paymentCode = '';
      this.changePayImgStatus = true;
      getOrderCode({}).then((res) => {
        if (res.code === 0) {
          this.sanQPayOrder = res.data.orderCode;
          this.innerVisible = true;
          this.getScanPayStatus();
        }
      });
    },
    // 查询审核状态
    getScanPayStatus() {
      this.setInterFlag = setInterval(() => {
        getScanPayStatus({ orderCode: this.sanQPayOrder }).then((res) => {
          if (res.code == 0) {
            // 0:未支付，1：已支付，-1：已失效
            if (res.data.status == 1) {
              this.$message({
                message: '已支付',
                type: 'success',
                duration: 1500
              });
              clearInterval(this.setInterFlag);
              this.confirmPay();
            } else if (res.data.status == -1) {
              this.$message.error('二维码已失效，请重新获取');
              clearInterval(this.setInterFlag);
              this.scanQPayLoading = false;
            }
            this.totalNum++;
            if (this.totalNum > 60) {
              clearInterval(this.setInterFlag);
              this.scanQPayLoading = false;
            }
          } else {
            clearInterval(this.setInterFlag);
            this.$message.error(res.msg);
          }
        });
      }, 1000);
    },
    // 提交
    confirmPay() {
      // if (!this.bankCode && this.choosePayStatus == 2) {
      //   this.$message.error("请输入银行流水号");
      //   return;
      // }
      if (this.choosePayStatus == 0) {
        this.$message('请选择支付方式!');
        return;
      }
      if (this.textarea.length > 50) {
        this.$message.error('请输入金额备注(50个字符以内)');
        return;
      }
      if (this.money < 0.01) {
        this.$message.error('输入金额不能小于0.01');
        return;
      }
      // if (!CheckBankNo(this.bankCode)) {
      //   this.$message.error("请输入正确银行卡账号");
      //   return;
      // }
      saveOrder({
        orderCode: this.sanQPayOrder,
        bankCode: this.bankCode,
        price: this.money,
        remark: this.textarea,
        payType: this.choosePayStatus
      }).then((res) => {
        if (res.code === 0) {
          if (this.choosePayStatus == 1) {
            this.$message({
              message: '现金支付成功！',
              type: 'success'
            });
          } else if (this.choosePayStatus == 2) {
            this.$message({
              message: '银行卡支付成功！',
              type: 'success'
            });
          } else if (this.choosePayStatus == 4) {
            this.$message({
              message: '扫码支付成功！',
              type: 'success'
            });
          }
          this.innerVisible = false;
          window.sessionStorage.successOrderId = res.data ? res.data : '';
          window.sessionStorage.successResulteMoney = this.money;
          window.sessionStorage.successOrderType = 2;
          this.$store.commit('deleteTabs', 'stage-quickCashier');
          window.sessionStorage.printOrderStatus = 1;
          this.$router.replace({
            name: 'stage-settlementSuccess'
          });
        } else {
          this.$message(res.msg);
        }
      });
    },
    clearBusinessLimit() {
      this.choosePayStatus = 0;
      clearInterval(this.setInterFlag);
    },
    scanQPaySubmit() {
      this.Lib.keyboardBlur();
      console.log('12312312321');
      toPayBefore({
        orderCode: this.sanQPayOrder,
        bankCode: this.bankCode,
        price: this.money,
        remark: this.textarea,
        payType: this.choosePayStatus
      }).then(() => {
        const data = {
          sceneType: 0, // 0：erp,1:店员端,2:pad,3:小程序粉丝端
          memberType: 0, // 0:不使用优惠，1：会员优惠，2：星球优惠)
          orderType: 1, // 0:服务开单，1：快捷收银，2：套餐购买,3: 还款
          orderCode: this.sanQPayOrder,
          barCode: this.paymentCode,
          payType: this.changePayImgStatus ? 0 : 1,
          money: this.money
        };
        this.scanQPayLoading = true;
        newBarCodePay(data).then((res) => {
          if (res.code == 0) {
            this.totalNum = 0;
            console.log();
          } else {
            this.paymentCode = '';
            getOrderCode({}).then((resTwo) => {
              this.sanQPayOrder = resTwo.data.orderCode;
              this.scanQPayLoading = false;
              this.$nextTick(() => {
                this.$refs.refsqp.focus();
              }, 100);
            });
          }
        });
      });
    }
  }
};
// eslint-disable-next-line no-unused-vars
function didGetQRCode(code) {

}
</script>

<style lang="less" scoped>
.need-to-pay {
  width: 228px;
  margin: 0 auto;
  text-align: left;
  color: #333333;
  font-size: 14px;
  &:first-child {
    margin-bottom: 10px;
  }
}
.payInfo {
  padding: 20px 30px;
  p {
    height: 15px;
    line-height: 15px;
    padding: 10px 0;
    color: #333333;
    font-size: 14px;
    b {
      font-weight: 600;
      color: #ff6565;
      font-size: 20px;
    }
    span {
      font-weight: 600;
      color: #ff6565;
      font-size: 18px;
    }
  }
}
.hdScanIcon {
  width: 16px;
  height: 16px;
  position: absolute;
  z-index: 1;
  margin: 10px 0 0 92px;
  padding: 12px 10px;
  cursor: pointer;
}
</style>

<style>
.input-with-select .el-input__inner {
  padding-left: 36px !important;
}
</style>
